import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Response } from '@angular/http';
import { CommonHttpService } from '../../../shared/services/http.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ClientModel } from '../../../shared/models/client.model';
import { AuthenticatedUserRepositoryService } from '../../../payment/services/authenticated-user-repository.service';
import { OauthService } from '../../../shared/services/oauth.service';
import { OrderDetails } from '../../models/orders/details';

@Component({
    selector: 'account-orders-details',
    templateUrl: './account.orders.details.component.html',
    styleUrls: ['./../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountOrdersDetailsComponent implements OnInit {
    public id;
    public loading = false;
    public client: ClientModel;
    public order: OrderDetails;
    public deliverable = false;
    public scheduled = false;

    constructor(
        protected route: ActivatedRoute,
        protected translate: TranslateService,
        protected titleService: Title,
        protected http: CommonHttpService,
        protected authenticatedUserRepository: AuthenticatedUserRepositoryService,
        protected oauth: OauthService,
        protected router: Router
    ) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.oauth.init();
            }
        });
        this.oauth.loadedAuthenticatedUser$.subscribe((client: ClientModel) => {
            this.client = client;
            this.showOrder();
        });
    }

    ngOnInit () {
        if (!this.clientIsDefined()) {
            this.client = this.authenticatedUserRepository.getUser();
        }

        this.route.params.subscribe(params => {
            this.id = +params['id'];
            this.translate
                .get('ACCOUNT.ORDERS.DETAILS.TITLE', {id: this.id})
                .subscribe(title => this.titleService.setTitle(title+ ' | ' + this.route.snapshot.data.storeConfigurations.store_name));
        });
    }

    /**
     * Call api to load order data
     **/
    public showOrder() {
        if (!this.clientIsDefined()) {
            // Wait until client is defined from authenticated user repository
            return;
        }

        this.loading = true;
        this.http
            .useAuth()
            .get(`account/clients/${this.client.id}/orders/${this.id}`)
            .subscribe((response: Response) => {
                this.setOrder(response.json().data);
                this.loading = false;
            });
    }
    /**
     * Check if order was already defined.
     **/
    public orderIsDefined() {
        return undefined !== this.order && null !== this.order;
    }
    /**
     * Check if order deliveries data is defined.
     **/
    private isDeliverable() {
        return this.order.deliveries !== undefined
            && this.order.deliveries.address !== undefined
            && this.order.deliveries.zip_code_range !== undefined;
    }
    /**
     * Check if order deliveries data is defined.
     **/
    private isScheduled() {
        return this.order !== undefined
            && this.order.schedule !== undefined
            && this.order.schedule.date !== undefined
            && this.order.schedule.period !== undefined;
    }
    /**
     * Check if client is defined from ahead template or from authenticated
     * user repository.
     **/
    private clientIsDefined() {
        return undefined !== this.client && null !== this.client;
    }
    /**
     * Set order property and its details properties.
     **/
    private setOrder(order) {
        this.order = order;
        this.deliverable = this.isDeliverable();
        this.scheduled = this.isScheduled();
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/account/orders/details/account.orders.details.component.ts